import { render, staticRenderFns } from "./createOfferDescription.vue?vue&type=template&id=5309c9a2&scoped=true&"
import script from "./createOfferDescription.vue?vue&type=script&lang=ts&"
export * from "./createOfferDescription.vue?vue&type=script&lang=ts&"
import style0 from "./createOfferDescription.vue?vue&type=style&index=0&id=5309c9a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309c9a2",
  null
  
)

export default component.exports